module.exports = __webpack_public_path__ + "img/landingpage-video-tablet-people.0f08f32e.svg";